import React, { useContext, useState, Fragment } from "react";
import * as statusColors from "constants/status-colors";
import { packClasses } from "Utils";
import { MinusCircleIcon, PencilIcon } from "@heroicons/react/solid";
import { CubeIcon } from "@heroicons/react/outline";
import { useField } from "formik";
import ContentPicker from "components/DesignSystem/ContentPicker";
import { useHistory } from "react-router-dom";
import { ContentContext } from "context/Content";

function DominantMediaField(props) {
    const [contentPickerState, setContentPickerState] = useState(false);
    const history = useHistory();
    const { state } = useContext(ContentContext);
    const [field] = useField(props);

    const onChange = (val) => {
        field.onChange({
            target: {
                id: field.id,
                name: field.name,
                getAttribute: function () {
                    return true;
                },
                value: val,
            },
        });
    };

    const openPicker = () => {
        setContentPickerState(true);
    };
    const closePicker = () => {
        setContentPickerState(false);
    };
    const handleMediaSelect = (item) => {
        onChange(item);
    };
    const handleMediaEdit = () => {
        history.push("/app/media/" + field.value.uuid);
    };
    const handleMediaClear = () => {
        onChange(-1);
    };

    if (state.loading) {
        return (
            <div>
                <div className="mt-0 h-52 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    if (field.value && field.value.id && field.value.attachment) {
        return (
            <div className="relative block w-full rounded text-center">
                <div className="relative" style={{ minHeight: "150px" }}>
                    <div className="absolute inset-0 z-0  w-full py-10 text-center">
                        <CubeIcon className="mx-auto h-10 w-10 animate-rotate-pulse text-gray-300" />
                    </div>
                    <img
                        className="relative z-0 rounded"
                        src={field.value.attachment.imgix_url.concat(
                            "?w=1000&ar=5:3&fit=crop&crop=faces"
                        )}
                        alt={field.value.attachment.title}
                    />
                </div>

                <div className="text-color-8000 absolute -bottom-1 left-0 flex w-full items-center space-x-4 rounded rounded-t-none border-t bg-white py-2 px-2 text-left text-xs">
                    <span
                        className={packClasses(
                            statusColors.background[field.value.status],
                            "rounded px-2 py-0.5 text-xs capitalize"
                        )}
                    >
                        {field.value.status}
                    </span>
                    <span className="text-xs capitalize">
                        {field.value.attachment.type}
                    </span>
                    <span className="text-xs">
                        {field.value.attachment.base_name}.
                        {field.value.attachment.extension}
                    </span>
                    <span className="flex-grow space-x-2 text-right text-xs">
                        <button
                            type="button"
                            onClick={handleMediaEdit}
                            className="text-underline text-green-600"
                        >
                            <span className="sr-only">Edit</span>
                            <PencilIcon className="h-4 w-4" />
                        </button>
                        <button
                            type="button"
                            onClick={handleMediaClear}
                            className="text-underline text-green-600"
                        >
                            <span className="sr-only">Clear</span>
                            <MinusCircleIcon className="h-4 w-4" />
                        </button>
                    </span>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <button
                type="button"
                onClick={() => {
                    openPicker();
                }}
                disabled={props.disabled}
                className="focus:outline-none relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mx-auto h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 4v16m8-8H4"
                    />
                </svg>{" "}
                <span className="mt-2 block text-sm font-medium text-gray-900">
                    Add dominant media
                </span>
            </button>
            <ContentPicker
                open={contentPickerState}
                onSelect={handleMediaSelect}
                onRequestClose={closePicker}
                allowMultiple={false}
                mediaType="image"
                type="media"
                listType="grid"
            />
        </Fragment>
    );
}

export default DominantMediaField;
